export default class GradientOrbs {
  constructor(canvas) {
    this.canvas = canvas;
    if (!this.canvas) return;

    this.ctx = this.canvas.getContext("2d");
    this.orbs = [
      { x: -75, y: -75, vx: 0.5, vy: 0.3, sizeFactor: 1, image: new Image() },
      { x: 66, y: 0, vx: -0.5, vy: -0.3, sizeFactor: 1, image: new Image() },
    ];

    this.setImages();

    this.imagesLoaded = 0;
    this.init();
  }

  init() {
    this.orbs.forEach((orb) => {
      orb.image.onload = () => {
        this.imagesLoaded++;
        if (this.imagesLoaded === this.orbs.length) {
          this.resizeCanvas();
          this.animate();
        }
      };
    });

    window.addEventListener("resize", () => this.resizeCanvas());
  }

  setImages() {
    const imagePaths = {
      purple: "/assets/gfx/orb-purple.png",
      green: "/assets/gfx/orb-green.png",
      orange: "/assets/gfx/orb-orange.png",
    };

    const oneKey = this.canvas.dataset.orbOne ?? "green";
    const twoKey = this.canvas.dataset.orbTwo ?? "purple";

    // If no orbs are set, use default
    if (this.canvas.dataset.orbOne == "" && this.canvas.dataset.orbTwo == "") {
      this.orbs[0].image.src = imagePaths["green"];
      this.orbs[1].image.src = imagePaths["purple"];
      return;
    }
    // If only one is set, use same for both
    if (this.canvas.dataset.orbOne == "" && this.canvas.dataset.orbTwo != "") {
      this.orbs[0].image.src = imagePaths[twoKey];
      this.orbs[1].image.src = imagePaths[twoKey];
      return;
    }
    if (this.canvas.dataset.orbTwo == "" && this.canvas.dataset.orbOne != "") {
      this.orbs[0].image.src = imagePaths[oneKey];
      this.orbs[1].image.src = imagePaths[oneKey];
      return;
    }
    // else, set orbs accordingly
    this.orbs[0].image.src = imagePaths[oneKey];
    this.orbs[1].image.src = imagePaths[twoKey];
  }

  resizeCanvas() {
    this.canvas.width = this.canvas.parentElement.clientWidth;
    this.canvas.height = this.canvas.parentElement.clientHeight;
  }

  updateOrbs() {
    const speedFactor = 0.33;
    this.orbs.forEach((orb) => {
      orb.x += orb.vx * speedFactor;
      orb.y += orb.vy * speedFactor;

      if (orb.x < -75 || orb.x > 75) orb.vx *= -1;
      if (orb.y < -75 || orb.y > 75) orb.vy *= -1;
    });
  }

  animate() {
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.orbs.forEach((orb) => {
      const orbSize = this.canvas.width * 0.95 * orb.sizeFactor;
      const px = this.canvas.width / 2 + (orb.x / 100) * this.canvas.width;
      const py = this.canvas.height / 2 + (orb.y / 100) * this.canvas.height;

      ctx.globalAlpha = 0.8;
      ctx.drawImage(
        orb.image,
        px - orbSize / 2,
        py - orbSize / 2,
        orbSize,
        orbSize
      );
    });

    this.updateOrbs();
    requestAnimationFrame(() => this.animate());
  }
}
